/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DynamicFields from 'shared/ui/components/form-components/DynamicFields.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import ImagePicker from 'shared/ui/components/form-components/pickers/ImagePicker.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';

const __vue_script__ = {
    name: 'RegistrationPage',

    components: {
        DynamicFields,
        HtmlEditor,
        ImagePicker
    },

    extends: WizardStep,

    data() {
        return {
            legalDocs: [],
            metadataFields: [],
            imagePickerExtensions: ['png', 'jpg', 'jpeg'],
            selectedBanners: null,
            ready: false
        };
    },

    watch: {
        selectedBanners() {
            this.form.banner = (this.selectedBanners || [])[0];
        }
    },

    async created() {
        try {
            const orgName = this.$services.org.getNameFromId(this.form.orgId);
            this.legalDocs = await this.$services.legal.getLegalDocumentsForOrg(orgName);
            this.metadataFields = await this.$services.metadata.getUserRegistrationFields();
            this.ready = true;
        } catch (error) {
            console.error('[RegistrationPage] Could not initialize form with default values', error.message);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"workspace-form",attrs:{"tag":"form"}},[_c('html-editor',{attrs:{"name":"description","label":_vm.$t('webinars.form.description'),"links":true,"enableCustomBstgLinks":false,"extras":false,"blockquote":true},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),(_vm.ready)?_c('dynamic-fields',{attrs:{"fields":_vm.metadataFields,"include-required":true,"legal-docs":_vm.legalDocs,"dropdown-anchor":"nw","label":_vm.$t('webinars.form.registration_fields'),"name":"fields[registration]"},model:{value:(_vm.form.registrationPageFields),callback:function ($$v) {_vm.$set(_vm.form, "registrationPageFields", $$v)},expression:"form.registrationPageFields"}}):_vm._e(),_c('image-picker',{staticClass:"banner-picker",attrs:{"name":"banner","modalZoomTitle":_vm.$t('webinars.form.banner'),"label":_vm.$t('webinars.form.banner'),"hint":_vm.$t('webinars.form.banner_hint'),"extensions":_vm.imagePickerExtensions,"height":692,"width":2880,"size":Math.pow( 1024, 2 ) * 10,"ratio":2880 / 692},model:{value:(_vm.selectedBanners),callback:function ($$v) {_vm.selectedBanners=$$v},expression:"selectedBanners"}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RegistrationPage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__